import { useState, FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { usePostHog } from 'posthog-js/react'
import { Button, toast } from '@itsrever/design-system'

const surveyID = '01961cc9-d1d3-0000-eac9-de769088d6ea'
const questionID = '9a156da7-20bb-4098-8a2b-2686881f2a96'

export const FeedbackSurvey = () => {
  const { t } = useTranslation()
  const posthog = usePostHog()
  const [isOpen, setIsOpen] = useState(false)
  const [feedback, setFeedback] = useState('')

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()

    posthog.capture('survey sent', {
      $survey_id: surveyID,
      [`$survey_response_${questionID}`]: feedback,
      $survey_questions: [
        {
          id: questionID,
          question: 'What can we do to improve our product?'
        }
      ]
    })

    toast({
      text: t('feedback.success'),
      variant: 'success'
    })

    setFeedback('')
    setIsOpen(false)
  }

  const handleDismiss = () => {
    setIsOpen(false)

    posthog.capture('survey dismissed', {
      $survey_id: surveyID // required
    })
  }

  if (!isOpen) {
    return (
      <div onClick={() => setIsOpen(true)}>
        <div className="flex cursor-pointer items-center gap-2 rounded-lg fill-[#99A0AE] p-2 text-[#99A0AE] hover:bg-[#2C3242] hover:fill-white hover:text-white hover:outline-1 hover:outline-[#353C4E]">
          <div>
            <span className="flex size-2">
              <span className="inline-flex size-full rounded-full bg-[#098FF9]" />
            </span>
          </div>
          <p className="text-sm">{t('feedback.give_feedback')}</p>
        </div>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="absolute bottom-[72px] left-2 w-[216px] overflow-hidden rounded-lg bg-shell shadow-lg">
        <div className="border-b border-[#1A2738] bg-[#1A2738] px-3 py-2">
          <h3 className="text-base font-medium text-white">
            {t('feedback.title')}
          </h3>
          <p className="mt-0.5 text-xs text-[#94A3B8]">
            {t('feedback.description')}
          </p>
        </div>

        <div className="p-3">
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder={t('feedback.placeholder')}
            className="mb-3 h-24 w-full rounded-lg border border-[#1A2738] bg-shell p-2 text-sm text-[#94A3B8] outline-none transition-all placeholder:text-[#64748B] focus:border-[#098FF9] focus:ring-1 focus:ring-[#098FF9]"
            rows={3}
          />

          <div className="flex justify-end gap-2">
            <Button
              onClick={handleDismiss}
              className="rounded-lg px-2.5 py-1.5 text-xs font-medium text-[#94A3B8] hover:bg-[#1A2738]"
            >
              {t('feedback.cancel')}
            </Button>
            <Button
              type="submit"
              disabled={!feedback.trim()}
              className="rounded-lg bg-[#098FF9] px-2.5 py-1.5 text-xs font-medium text-white transition-all hover:bg-[#0870C7] disabled:opacity-50"
            >
              {t('feedback.submit')}
            </Button>
          </div>
        </div>
      </div>
    </form>
  )
}
